import './Plugins.css'

import { Location, Route, Routes, useLocation } from 'react-router-dom'

import { lazyPage } from '@/lib/lazy-load'
import { useParamId } from '@/hooks/useParamId'
import { ORG_ROUTE, PROJECT_PLUGIN_ROUTE } from '@/shared/constants'
import { useLocationChange } from '@/shared/makyo-hooks'
import { WrapperProps } from '@/shared/routes'
import { HorizontalMenu } from '@/components'
import Layout from '@/components/Layout'

import PluginFilterProvider, { initialPluginFilterState, usePluginFilterContext } from './PluginFilterProvider'

const PluginPage = lazyPage(() => import('./PluginPage'))
const PluginsCredentialsPage = lazyPage(() => import('./PluginCredentialsPage'))

/**
 * pre process plugin nav link
 */
function pluginNavLink(path: string, location: Location, id?: string) {
  const pathname = location.pathname
  const withSlash = path ? `/${path}` : ''
  const ident = id ? id : pathname.split('/')[2]
  return `${ORG_ROUTE}/${ident}/${PROJECT_PLUGIN_ROUTE}${withSlash}`
}

/**
 * project plugins routes
 * -> `/p/settings/plugins/{pluginRoutes}`
 */
const pluginRoutes = [
  {
    name: 'Plugins',
    index: true,
    component: PluginPage,
  },
  {
    path: 'credentials',
    name: 'Credentials',
    component: PluginsCredentialsPage,
  },
  // {
  //   path: 'all',
  //   name: 'All Plugins',
  //   component: AllPluginsList,
  // },
  // {
  //   path: 'popular',
  //   name: 'Popular',
  //   component: AllPluginsList,
  // },
  // {
  //   path: 'top',
  //   name: 'Top Rated',
  //   component: AllPluginsList,
  // },
  // {
  //   path: 'my-favorites',
  //   name: 'My Favorites',
  //   component: AllPluginsList,
  // },
  // {
  //   path: 'my-reviews',
  //   name: 'My Reviews',
  //   component: MyReviewList,
  // },
]

/**
 * Plugin routes wrapper
 */
function PluginsRoute() {
  const { setPricing, setCategories, setTypes } = usePluginFilterContext()

  // Use the useLocationChange hook to listen for changes in the location
  useLocationChange((location, prev) => {
    // If the previous location is undefined or null, just return
    if (prev === undefined || prev === null) {
      return
    } else {
      // If the pathname of the current location is not the same as the previous location's
      // reset the pricing, categories, and types filters to their initial states
      // This is done to ensure that the filters do not persist across different pages
      if (location.pathname !== prev.pathname) {
        setPricing(initialPluginFilterState.pricing)
        setCategories(initialPluginFilterState.categories)
        setTypes(initialPluginFilterState.types)
      }
    }
  })

  return (
    <Routes>
      {pluginRoutes.map(({ component: Comp, name, ...rest }) => {
        return <Route key={name} {...rest} element={<Comp />} />
      })}
    </Routes>
  )
}

/**
 * OrgPluginsRoutes
 */
export default function OrgPluginsRoutes({ title }: WrapperProps) {
  const location = useLocation()
  const orgId = useParamId('org')

  return (
    <PluginFilterProvider>
      <Layout
        title={title}
        beforeContent={
          <HorizontalMenu
            menu={pluginRoutes}
            getTo={(path) => {
              return pluginNavLink(path, location, orgId)
            }}
          />
        }
        // actions={<PluginFilterDropdown />}
      >
        <PluginsRoute />
      </Layout>
    </PluginFilterProvider>
  )
}
